// @docs https://[domain]/api/v1/docs
export default {
  List: "/roles",
  ListShort: "/roles/short",
  Detail: "/roles",
  Create: "/roles",
  Update: "/roles",
  Delete: "/roles",
};
